import { defineComponent as _defineComponent } from 'vue';
import { useRecordList } from '@blade-sxp/monitoring-center/pages/record/utils/useRecordList';
import { useRecordDetail } from '@blade-sxp/monitoring-center/pages/record/utils/useRecordDetail';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import DetailsPage from '@blade/common/pages/result-details/index.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'record-list',
    props: {
        query: null
    },
    setup(__props, { expose }) {
        const props = __props;
        const { loading, snapImageList, pagination, form, activeBorderColor, setPrivacyMode, handleSizeChange, handleCurrentChange, getSimilarity, updateData, groupTimeChange } = useRecordList(props.query);
        const { viewDetails, closeDetails, next, prev, addRoute, deletedRoute, showBtn, dialogVisible, viewList, activeIndex, showPath, detailLoading, maxNums } = useRecordDetail(snapImageList);
        const routeType = props.query.type || 'features';
        expose({ updateData, groupTimeChange });
        return { __sfc: true, props, loading, snapImageList, pagination, form, activeBorderColor, setPrivacyMode, handleSizeChange, handleCurrentChange, getSimilarity, updateData, groupTimeChange, viewDetails, closeDetails, next, prev, addRoute, deletedRoute, showBtn, dialogVisible, viewList, activeIndex, showPath, detailLoading, maxNums, routeType, BlurPicture, DetailsPage };
    }
});
